import { Modal } from 'bootstrap';

class carouselModal {
    constructor() {
        const ID = {
            videoButton: "site-hero-banner-video-btn",
            videoData: "post-video-url",
            modalFrame: "modal-video-frame"
        }
        
        const videoButton = document?.getElementById(ID.videoButton);
        const videoData = document?.getElementById(ID.videoData);
        const modalFrame = document?.getElementById(ID.modalFrame);
        const myModalEl = document?.getElementById('videoModal');
        
        let myModal = null;

        const init = () => {
            if (myModalEl) {
                myModal = new Modal(myModalEl);
                addPlayButtonListener();
                addModalHideListener();
            }
        }
        
        const addPlayButtonListener = () => {
            if (videoButton != null) {
                videoButton?.addEventListener('click', () => {
                    const videoTitleData = videoData?.dataset.title;
                    const videoUrlData = videoData?.dataset.videourl; 
                    updateFrameData(videoTitleData, videoUrlData);
                    myModal.show();
                });
            }
        }

        const addModalHideListener = () => {
            if (myModalEl) {
                myModalEl.addEventListener('hidden.bs.modal', () => {
                    // Clear the iframe source when modal is hidden
                    if (modalFrame) {
                        modalFrame.src = '';
                    }
                    // Remove any lingering backdrop
                    const backdrop = document.querySelector('.modal-backdrop');
                    if (backdrop) {
                        backdrop.remove();
                    }
                    // Remove modal-open class from body
                    document.body.classList.remove('modal-open');
                    // Remove inline styles from body
                    document.body.style.removeProperty('padding-right');
                    document.body.style.removeProperty('overflow');
                });
            }
        }
        
        const updateFrameData = (title, url) => {
            if (modalFrame) {
                modalFrame.src = url;
                modalFrame.title = title;
            }
        }

        init();
    }
}

export default carouselModal;
